import { useContext } from 'react';

import { Typography } from '@mui/material';
import { wellzTheme as muiWellzTheme } from '@wellz-theme/mui';
import { FormattedMessage, useIntl } from 'react-intl';
import { wellzTheme } from 'theme';
import {
  formatDate,
  getFormattedTime,
  getFullNameInitials,
} from 'utils/helpers';

import { DrawerInviteScheduleContext } from 'components/DrawerInviteSchedule/context/DrawerInviteScheduleContext';

import * as S from '../../styles';

const ConfirmInvite: React.FC = () => {
  const intl = useIntl();
  const { date, hour, patient } = useContext(DrawerInviteScheduleContext);

  if (!date || !hour || !patient) return null;

  return (
    <S.Body>
      <Typography
        variant="h5"
        style={{ marginBottom: muiWellzTheme.spacing(5) }}
      >
        <FormattedMessage id="CPPLATFORM.CPINVITECONFIRM.TITLE" />
      </Typography>

      <S.ContainerData>
        <Typography
          variant="overline"
          style={{ marginBottom: muiWellzTheme.spacing(0.5) }}
        >
          <FormattedMessage id="CPPLATFORM.CPINVITECONFIRM.TITLELABEL1" />
        </Typography>

        <S.ContainerRow className="patient-avatar">
          <S.PatientAvatar>
            {getFullNameInitials(patient.fullName)}
          </S.PatientAvatar>

          <Typography variant="body1">{patient.fullName}</Typography>
        </S.ContainerRow>

        <Typography
          variant="overline"
          style={{ marginBottom: muiWellzTheme.spacing(0.5) }}
        >
          <FormattedMessage id="CPPLATFORM.CPINVITECONFIRM.TITLELABEL2" />
        </Typography>

        <S.ContainerRow>
          <S.CalendarIcon />
          <Typography
            variant="body1"
            style={{ marginRight: muiWellzTheme.spacing(4) }}
          >
            {formatDate(date.toString(), { locale: intl.locale })}
          </Typography>
          <S.HourIcon />
          <Typography variant="body1">
            {getFormattedTime(hour.toString(), { locale: intl.locale })}
          </Typography>
        </S.ContainerRow>
      </S.ContainerData>

      <S.ContainerInvite>
        <Typography
          variant="caption"
          style={{ marginBottom: muiWellzTheme.spacing(2) }}
        >
          <FormattedMessage id="CPPLATFORM.CPINVITECONFIRM.SUBTITLEMESSAGE" />
        </Typography>

        <S.ContainerWhite>
          <Typography
            variant="body2"
            style={{ color: wellzTheme.colors.text.disabled }}
          >
            <FormattedMessage
              id="CPPLATFORM.CPINVITECONFIRM.MESSAGEBODYTEXTFRONT"
              values={{ patientName: patient.fullName }}
            />
          </Typography>
        </S.ContainerWhite>
      </S.ContainerInvite>
    </S.Body>
  );
};

export default ConfirmInvite;
